import { quickEntries } from "@/mocks/homeContent";

export default function EntryRail() {
  return (
    <section className="relative z-10 w-full bg-background-50">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="-mt-8 overflow-hidden rounded-xl border border-background-200 bg-background-50 md:-mt-10">
          <div className="flex items-center justify-between border-b border-background-200 bg-background-100 px-4 py-3 md:px-6">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-door-open-line text-sm" />
              </span>
              <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                快速入口条
              </span>
            </div>
            <span className="hidden items-center gap-1 text-xs text-foreground-500 sm:flex">
              <i className="ri-arrow-right-down-line" />
              点击进入对应专区
            </span>
          </div>

          <div className="no-scrollbar flex overflow-x-auto lg:grid lg:grid-cols-5">
            {quickEntries.map((entry, index) => (
              <a
                key={entry.id}
                href="#latest"
                className={`group flex min-w-[190px] flex-1 items-center gap-3 px-4 py-4 transition-colors hover:bg-background-100 md:px-5 lg:min-w-0 ${
                  index !== 0 ? "lg:border-l lg:border-background-200" : ""
                }`}
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                  <i className={`${entry.icon} text-xl`} />
                </span>
                <span className="flex flex-col">
                  <span className="whitespace-nowrap text-sm font-medium text-foreground-900">
                    {entry.title}
                  </span>
                  <span className="whitespace-nowrap text-xs text-foreground-500">{entry.note}</span>
                </span>
                <i className="ri-arrow-right-s-line ml-auto text-secondary-400 transition-transform group-hover:translate-x-0.5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}